import { c as _c } from "react/compiler-runtime";
import { IconButton, Tooltip, useDialog, useTranslationContext } from 'platform/components';
import { suffixTestId, TestIdProps } from 'shared/web';
import { selectQueryId } from '../../../../store/createEagGridStore';
import { useEagGridSelector } from '../../../../store/useEagGridSelector';
import { ExportDialog } from './components/ExportDialog/ExportDialog';
type ExportButtonProps = TestIdProps;
export function ExportButton(props) {
  const $ = _c(23);
  const t = useTranslationContext();
  const [isOpen, onOpen, onClose] = useDialog();
  const queryId = useEagGridSelector(selectQueryId);
  let t0;
  if ($[0] !== t) {
    t0 = t("page.datagrid.button.export");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("page.datagrid.button.export");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !queryId;
  let t3;
  if ($[4] !== props) {
    t3 = suffixTestId("exportButton", props);
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onOpen || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <IconButton icon="file/download" onClick={onOpen} aria-label={t1} isDisabled={t2} data-testid={t3} />;
    $[6] = onOpen;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t0 || $[12] !== t4) {
    t5 = <Tooltip label={t0}>{t4}</Tooltip>;
    $[11] = t0;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props) {
    t6 = suffixTestId("exportButton", props);
    $[14] = props;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isOpen || $[17] !== onClose || $[18] !== t6) {
    t7 = <ExportDialog isOpen={isOpen} onClose={onClose} data-testid={t6} />;
    $[16] = isOpen;
    $[17] = onClose;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}